import * as React from "react";
import Modal from "../../ui/modal/Modal";
import ButtonSecondary from "../../../hiberUiKit/src/atoms/Buttons/ButtonSecondary";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import "./workspaceModal.scss";

interface IProps {
	viewName: string;
	onClose: () => void;
	onSave: () => void;
}

interface IState {
	isLoading: boolean;
}

export default class RemoveFromFavouritesModal extends React.PureComponent<IProps, IState> {

	constructor(props: IProps) {
		super(props);

		this.state = {isLoading: false};
	}

	render() {
		return (
			<Modal onCloseClicked={this.props.onClose}
				   title={<span>Remove <strong>{this.props.viewName}</strong> from favourites?</span>}
				   autoWidth
				   customClass={"c-workspace-modal"}>
				<div className={"c-buttons-box"}>
					<ButtonSecondary label={"Cancel"} onClick={this.props.onClose}/>
					<ButtonPrimary label={"Remove"}
								   onClick={() => this.setState({isLoading: true}, () => this.props.onSave())}
								   disabled={this.state.isLoading}
								   isLoading={this.state.isLoading}/>
				</div>
			</Modal>
		)
	}
}